export const THROW_ERROR = 'THROW_ERROR';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const REMOVE_LOADING = 'REMOVE_LOADING';

export const SIDEBAR_TOGGLE = 'SIDEBAR_TOGGLE';

export const OFFSIDEBAR_TOGGLE = 'OFFSIDEBAR_TOGGLE';
export const OFFSIDEBAR_TOGGLE_MODULO = 'OFFSIDEBAR_TOGGLE_MODULO';
export const OFFSIDEBAR_TOGGLE_LOGIN = 'OFFSIDEBAR_TOGGLE_LOGIN';
export const OFFSIDEBAR_TOGGLE_ACESSIBILIDADE =
  'OFFSIDEBAR_TOGGLE_ACESSIBILIDADE';
export const OFFSIDEBAR_TOGGLE_USUARIO = 'OFFSIDEBAR_TOGGLE_USUARIO';
export const OFFSIDEBAR_USUARIO_ATIVO_E_ENTIDADE_TOGGLE =
  'OFFSIDEBAR_USUARIO_ATIVO_E_ENTIDADE_TOGGLE';
export const OFFSIDEBAR_USUARIO_ATIVO_E_ENTIDADE_INATIVA =
  'OFFSIDEBAR_USUARIO_ATIVO_E_ENTIDADE_INATIVA';
export const OFFSIDEBAR_TURNOFF_ALL_FEATURES =
  'OFFSIDEBAR_TURNOFF_ALL_FEATURES';

export const OFFSIDEBAR_TOGGLE_VERSAO = 'OFFSIDEBAR_TOGGLE_VERSAO';

export const MAINTANCE = 'MAINTANCE';

export const UNMAINTANCE = 'UNMAINTANCE';

export const ACESSIBILITYSYLE = 'ACESSIBILITYSYLE';
